import { useContract } from "@react-dapp/utils"
import { EXCHANGE_ADDRESS } from "../config/config";
import EXCHANGE_ABI from '../assets/abi/exchange_abi.json';

export const useExchange = () => {
    return useContract(EXCHANGE_ABI, EXCHANGE_ADDRESS)
}